export default __webpack_public_path__ + "static/media/address.c221f54a.svg";